import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'

import Component from '../components/address.step'
import actions from '../actions/address'
import {push} from 'react-router-redux'

class Container extends React.Component {

  continue = () => {
    this.props.save()
      .then(success => {
        if (success) this.props.requestNextStep()
      })
  }

  render() {
    return <Component {...this.props} continue={this.continue}/>
  }

  static propTypes = {
    requestNextStep: PropTypes.func.isRequired,
    save: PropTypes.func.isRequired,
  }
}

const mapStateToProps = state => {
  const data = state.ui.depositV2.address
  return {
    add: {
      address: data.getIn(['add', 'address']),
      number: data.getIn(['add', 'number']),
      floor: data.getIn(['add', 'floor']),
      apartment: data.getIn(['add', 'apartment']),
      postalCode: data.getIn(['add', 'postalCode']),
      emptyFieldErrors: data.getIn(['add', 'emptyFieldErrors']).toObject(),
    },
    isFormLoading: data.get('isFetching') || state.ui.deposit.start.get('isFetching'),
    isButtonLoading: data.get('isSaving') || data.get('isModifying'),
    isButtonDisabled: state.ui.deposit.start.get('isFetching'),
    error: data.get('error'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    save: () => dispatch(actions.saveAdd()),
    modifyTransaction: () => dispatch(actions.modifyTransaction()),
    setAddress: address => dispatch(actions.setAddress(address)),
    setFloor: floor => dispatch(actions.setFloor(floor)),
    setApartment: apartment => dispatch(actions.setApartment(apartment)),
    setPostalCode: postalCode => dispatch(actions.setPostalCode(postalCode)),
    setStreetNumber: number => dispatch(actions.setStreetNumber(number)),
    updateUrl: () => dispatch(push({search: '?s=direccion'})),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Container)



// WEBPACK FOOTER //
// ./src/sections/depositV2/containers/address.js